module.exports = __webpack_public_path__ + "static/media/apartment14.6c2edca3.jpg";